import { call, put, throttle, takeLatest, select } from "redux-saga/effects";
import * as fieldsConfigActions from "../actions/fieldsActions";
import {
  getRequestTypes,
  getMaintenanceLevels,
  getServiceTypes,
  getRegions,
  getWeekDays,
  getSubjects,
  getRequestStatuses,
  getOrderStatuses,
  getRoles,
  getVehicleCategories,
  getCitizenships,
  getIdentityDocuments,
  getForeignLanguages,
  getProfileStatus,
  getDocumentsFillTypes,
  getDocumentsStatuses,
  getDocumentsTypes,
  getServiceAdditionals
} from "../../api/filters";
import { getRequestViews } from "../../api/filters/getRequestViews";
import { getPerformers } from "../../api/filters/getPerformers";
import { getMonetizationTemplatesRequest } from "../../api/filters/getMonetizationTemplates";
import { checkActiveProfile } from "../../../modules/Authorization/redux/actions/CheckActiveProfile";
import { getPaymentMethodsRequest } from "../../api/filters/getPaymentMethods";

const getActiveProfileId = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.profileId
  );
};

function* getRequestStatusesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getRequestStatuses, payload);
    yield put(fieldsConfigActions.getRequestStatusesSuccess(response));
  } catch (error) {
    yield put(fieldsConfigActions.getRequestStatusesError(error));
  }
}

function* getRequestTypesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getRequestTypes, payload);
    yield put(fieldsConfigActions.getRequestTypesSuccess(response));
  } catch (error) {
    yield put(fieldsConfigActions.getRequestTypesError(error));
  }
}

function* getServiceTypesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getServiceTypes, payload);
    yield put(fieldsConfigActions.getServiceTypesSuccess(response));
  } catch (error) {
    yield put(fieldsConfigActions.getServiceTypesError(error));
  }
}

function* getMaintenanceLevelsSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getMaintenanceLevels, payload);
    yield put(fieldsConfigActions.getMaintenanceLevelsSuccess(response));
  } catch (error) {
    yield put(fieldsConfigActions.getMaintenanceLevelsError(error));
  }
}

function* getRegionsSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getRegions, payload);
    yield put(fieldsConfigActions.getRegionsSuccess(response));
  } catch (error) {
    yield put(fieldsConfigActions.getRegionsError(error));
  }
}

function* getWeekDaysSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getWeekDays, payload);
    yield put(fieldsConfigActions.getWeekDaysSuccess(response));
  } catch (error) {
    yield put(fieldsConfigActions.getWeekDaysError(error));
  }
}

function* getSubjectsSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getSubjects, payload);
    yield put(fieldsConfigActions.getSubjectsSuccess(response));
  } catch (error) {
    yield put(fieldsConfigActions.getSubjectsError(error));
  }
}

function* getRolesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getRoles, payload);
    yield put(fieldsConfigActions.getRolesSuccess(response));
  } catch (error) {
    yield put(fieldsConfigActions.getRolesError(error));
  }
}

function* getVehicleCategoriesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getVehicleCategories, payload);
    yield put(fieldsConfigActions.getVehicleCategoriesSuccess(response));
  } catch (error) {
    yield put(fieldsConfigActions.getVehicleCategoriesError(error));
  }
}

function* getCitizenshipsSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getCitizenships, payload);
    yield put(fieldsConfigActions.getCitizenshipsSuccess(response));
  } catch (error) {
    yield put(fieldsConfigActions.getCitizenshipsError(error));
  }
}

function* getIdentityDocumentsSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getIdentityDocuments, payload);
    yield put(fieldsConfigActions.getIdentityDocumentsSuccess(response));
  } catch (error) {
    yield put(fieldsConfigActions.getIdentityDocumentsError(error));
  }
}

function* getForeignLanguagesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getForeignLanguages, payload);
    yield put(fieldsConfigActions.getForeignLanguagesSuccess(response));
  } catch (error) {
    yield put(fieldsConfigActions.getForeignLanguagesError(error));
  }
}

function* getProfileStatusSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getProfileStatus, payload);
    yield put(fieldsConfigActions.getProfileStatusSuccess(response));
  } catch (error) {
    yield put(fieldsConfigActions.getProfileStatusError(error));
  }
}

function* getRequestViewsSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getRequestViews, payload);
    yield put(fieldsConfigActions.getRequestViewsSuccess(response));
  } catch (error) {
    yield put(fieldsConfigActions.getRequestViewsError(error));
  }
}

function* getOrderStatusesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getOrderStatuses, payload);
    yield put(fieldsConfigActions.getOrderStatusesSuccess(response));
  } catch (error) {
    yield put(fieldsConfigActions.getOrderStatusesError(error));
  }
}

function* getDocumentsFillTypesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getDocumentsFillTypes, payload);
    yield put(fieldsConfigActions.getDocumentsFillTypesSuccess(response));
  } catch (error) {
    yield put(fieldsConfigActions.getDocumentsFillTypesFailure(error));
  }
}

function* getDocumentsStatusesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getDocumentsStatuses, payload);
    yield put(fieldsConfigActions.getDocumentsStatusesSuccess(response));
  } catch (error) {
    yield put(fieldsConfigActions.getDocumentsStatusesFailure(error));
  }
}

function* getDocumentsTypesSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getDocumentsTypes, payload);
    yield put(fieldsConfigActions.getDocumentsTypesSuccess(response));
  } catch (error) {
    yield put(fieldsConfigActions.getDocumentsTypesFailure(error));
  }
}

function* getServiceAdditionalsSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(getServiceAdditionals, payload);
    yield put(fieldsConfigActions.getServiceAdditionalsSuccess(response));
  } catch (error) {
    yield put(fieldsConfigActions.getServiceAdditionalsError(error));
  }
}

function* getPerformersSaga(action) {
  const activeProfile = yield select(getActiveProfileId);
  if (activeProfile) {
    try {
      const response = yield call(getPerformers, activeProfile);
      yield put(fieldsConfigActions.getPerformersSuccess(response));
    } catch (error) {
      yield put(fieldsConfigActions.getPerformersFailure(error));
    }
  } else {
    yield put(checkActiveProfile());
    yield put(fieldsConfigActions.getPerformers());
  }
}

function* getMonetizationTemplatesSaga(action) {
  try {
    const response = yield call(getMonetizationTemplatesRequest);
    yield put(fieldsConfigActions.getMonetizationTemplatesSuccess(response));
  } catch (error) {
    console.log("error");
    yield put(fieldsConfigActions.getMonetizationTemplatesError(error));
  }
}

function* getPaymentMethodsSaga(action) {
  try {
    const response = yield call(getPaymentMethodsRequest);
    yield put(fieldsConfigActions.getPaymentMethodsSuccess(response));
  } catch (error) {
    console.log("error");
    yield put(fieldsConfigActions.getPaymentMethodsError(error));
  }
}

export function* fieldsConfigWatcher() {
  yield throttle(
    100,
    fieldsConfigActions.getRequestTypes.toString(),
    getRequestTypesSaga
  );
  yield throttle(
    200,
    fieldsConfigActions.getServiceTypes.toString(),
    getServiceTypesSaga
  );
  yield throttle(
    300,
    fieldsConfigActions.getMaintenanceLevels.toString(),
    getMaintenanceLevelsSaga
  );
  yield throttle(
    400,
    fieldsConfigActions.getPaymentMethods.toString(),
    getPaymentMethodsSaga
  );
  yield throttle(
    500,
    fieldsConfigActions.getRegions.toString(),
    getRegionsSaga
  );
  yield throttle(
    600,
    fieldsConfigActions.getWeekDays.toString(),
    getWeekDaysSaga
  );
  yield throttle(
    700,
    fieldsConfigActions.getSubjects.toString(),
    getSubjectsSaga
  );
  yield throttle(
    800,
    fieldsConfigActions.getRequestStatuses.toString(),
    getRequestStatusesSaga
  );
  yield takeLatest(fieldsConfigActions.getRoles.toString(), getRolesSaga);
  yield takeLatest(
    fieldsConfigActions.getVehicleCategories.toString(),
    getVehicleCategoriesSaga
  );
  yield takeLatest(
    fieldsConfigActions.getCitizenships.toString(),
    getCitizenshipsSaga
  );
  yield takeLatest(
    fieldsConfigActions.getIdentityDocuments.toString(),
    getIdentityDocumentsSaga
  );
  yield takeLatest(
    fieldsConfigActions.getForeignLanguages.toString(),
    getForeignLanguagesSaga
  );
  yield takeLatest(
    fieldsConfigActions.getProfileStatus.toString(),
    getProfileStatusSaga
  );
  yield throttle(
    100,
    fieldsConfigActions.getRequestViews.toString(),
    getRequestViewsSaga
  );
  yield takeLatest(
    fieldsConfigActions.getOrderStatuses.toString(),
    getOrderStatusesSaga
  );
  yield takeLatest(
    fieldsConfigActions.getDocumentsFillTypes.toString(),
    getDocumentsFillTypesSaga
  );
  yield takeLatest(
    fieldsConfigActions.getDocumentsStatuses.toString(),
    getDocumentsStatusesSaga
  );
  yield takeLatest(
    fieldsConfigActions.getDocumentsTypes.toString(),
    getDocumentsTypesSaga
  );
  yield takeLatest(
    fieldsConfigActions.getServiceAdditionals.toString(),
    getServiceAdditionalsSaga
  );
  yield takeLatest(
    fieldsConfigActions.getPerformers.toString(),
    getPerformersSaga
  );
  yield takeLatest(
    fieldsConfigActions.getMonetizationTemplates.toString(),
    getMonetizationTemplatesSaga
  );
}
